var _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1641_8033",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 18,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83984 0H20.1886V10.3129H3.83984V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1641_8033)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1855 10.2868C20.1855 10.1713 20.1855 8.6691 20.1855 8.56467C20.1853 7.70081 20.1939 8.97236 20.1832 8.10871C20.1657 6.71288 19.8114 5.40055 19.1249 4.19521C16.8919 0.274009 12.0889 -1.14724 8.15692 1.00054C5.68342 2.35175 4.23716 4.49633 3.91535 7.33413C3.79029 8.43696 3.86241 7.42703 3.84533 8.54246C3.84343 8.65564 3.84512 10.1666 3.84512 10.3129L5.47696 10.3075C5.47696 9.30594 5.45988 9.08426 5.48139 8.1258C5.50754 6.95014 5.80995 5.84497 6.42153 4.83973C7.88382 2.43589 10.5524 1.2628 13.3211 1.79606C16.1187 2.33509 18.3168 4.80108 18.5127 7.6739C18.5779 8.63066 18.5439 7.45863 18.5547 8.41923C18.5566 8.57172 18.5551 10.1222 18.5551 10.3073L20.1855 10.2868Z",
    fill: "#9D1131"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9564 22.699C12.3733 22.699 11.985 22.6614 11.9319 22.6561L12.105 20.9175C12.1149 20.9186 13.1162 21.016 14.3305 20.8722C15.3837 20.7477 16.8238 20.4124 17.7041 19.5219C18.3698 18.8481 18.6372 17.9405 18.5219 16.7471L20.2389 16.5767C20.406 18.3014 19.962 19.7096 18.9194 20.7618C17.2469 22.45 14.457 22.699 12.9564 22.699Z",
    fill: "#9D1131"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1641_8033",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 8,
    width: 9,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9111 8.88916H24.0002V18.2965H16.9111V8.88916Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1641_8033)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5551 8.90966C18.3048 8.90966 18.0869 8.90795 17.8693 8.90988C17.2562 8.91543 16.9125 9.26417 16.9121 9.88841C16.9108 12.3732 16.9108 14.858 16.9123 17.3428C16.9125 17.9277 17.2585 18.2767 17.8429 18.2886C18.0215 18.2923 18.2004 18.2893 18.4418 18.2893L20.3065 18.2965C20.5901 18.2549 20.8847 18.2747 21.1631 18.2139C22.8553 17.844 23.9861 16.4215 23.9966 14.6673C24.001 13.9491 24.0019 13.2306 23.9964 12.5124C23.9825 10.6532 22.7138 9.19413 20.894 8.94533C20.6688 8.91436 20.4404 8.90859 20.1854 8.88916",
    fill: "#F44176"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1641_8033",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 8,
    height: 11
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.90857H7.11953V18.291H0V8.90857Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1641_8033)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47682 8.90973C5.73621 8.90973 5.97177 8.90674 6.20733 8.91037C6.7744 8.91934 7.11794 9.26744 7.11836 9.84192C7.12005 12.3461 7.11984 14.8501 7.11836 17.3544C7.11794 17.8878 6.80224 18.2731 6.29126 18.2797C5.26656 18.293 4.23912 18.3064 3.21695 18.246C1.66124 18.1537 0.262634 16.8933 0.0856997 15.2241C-0.0281793 14.1501 -0.028812 13.0436 0.0852779 11.9698C0.266852 10.2594 1.71417 9.00006 3.4154 8.91592C3.54678 8.9093 3.679 8.91507 3.84497 8.91507",
    fill: "#F44176"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1641_8033",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 19,
    width: 6,
    height: 5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8335 19.5737H14.2043V24H9.8335V19.5737Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1641_8033)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2043 21.7869C14.2043 23.0091 13.2258 24 12.0189 24C10.812 24 9.8335 23.0091 9.8335 21.7869C9.8335 20.5647 10.812 19.5737 12.0189 19.5737C13.2258 19.5737 14.2043 20.5647 14.2043 21.7869Z",
    fill: "#F44176"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5549 10.3074L20.1853 10.2869V8.88916L18.5556 8.90966C18.5556 9.42926 18.5549 10.1818 18.5549 10.3074Z",
    fill: "#700C1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2386 16.5766C20.2386 16.5766 18.5243 16.5621 18.5255 16.5766C18.5759 17.149 18.5384 17.8495 18.415 18.2894C18.4241 18.2894 18.4321 18.2892 18.4416 18.2892L20.1837 18.296C20.2784 17.764 20.298 17.1908 20.2386 16.5766Z",
    fill: "#700C1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84427 8.91501C3.84406 9.40492 3.8449 10.2081 3.8449 10.3128L5.47675 10.3074C5.47675 9.96423 5.47485 9.46044 5.47295 8.90967L3.8449 8.91501H3.84427Z",
    fill: "#700C1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0825 22.669C12.255 22.6818 12.5608 22.6991 12.9562 22.6991C13.2656 22.6991 13.6315 22.6874 14.0292 22.6558C14.1416 22.389 14.2045 22.0954 14.2045 21.787C14.2045 21.4729 14.1389 21.1745 14.0223 20.9039C12.9516 20.9994 12.1142 20.9187 12.1051 20.9176L12.0825 22.669Z",
    fill: "#700C1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.e4c9f87dbf673d9b41372483b2fc9d6b.svg";
export { ForwardRef as ReactComponent };